import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { StudentCheckTestService } from './student-check-test.service';
import { Injectable } from '@angular/core';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CtQuestionsPageResolver implements Resolve<any> {


  constructor(private testService: StudentCheckTestService, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const learningObjectiveId = route.paramMap.get('ctId');
    const courseId = route.paramMap.get('courseId');
    const paperId = route.paramMap.get('paperId');
    const testType = route.paramMap.get('testType');
    const modeType = route.paramMap.get('modeType');

    let testTypeLink = 'cumulative-test';
    if (testType === 'homework') {
      testTypeLink = 'homework';
    }
    if (testType === 'quiz') {
      testTypeLink = 'quiz';
    }

    return this.testService.getCTTestQuestion(+learningObjectiveId, +courseId)
    .pipe(
      switchMap((result) => {
        // @ts-ignore
        if (result.data?.feedbackShared && modeType === 'review') {
          this.router.navigate([`report/${testTypeLink}/${courseId}/${learningObjectiveId}/${paperId}/view`]);
        }
        // @ts-ignore
        return of({data: result.data});
      }),
      catchError(val => {
        return of(`I caught: ${ val }`);
      }
    ));
  }
}


